/** Parts rendered in the first commit; enough to fill the screen quickly. */
export const INITIAL_RENDERED_PARTS = 8;
/** Parts added per idle callback afterwards, small enough to keep the page responsive. */
export const PARTS_PER_RENDER_CHUNK = 8;

/** Render limit after the next chunk, capped at the number of parts. */
export const nextRenderLimit = (limit: number, totalParts: number, chunk = PARTS_PER_RENDER_CHUNK) =>
    Math.min(totalParts, limit + chunk);

/** Render limit that guarantees the part at `partIndex` (0-based) is rendered. */
export const renderLimitToShowPart = (limit: number, partIndex: number) =>
    partIndex < 0 ? limit : Math.max(limit, partIndex + 1);
